import toNumber from 'lodash/toNumber';

import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { CountryCode } from '@/graphql/saleor/api';

export const supportedCountry: CountryCode[] = ['JP'];

export const STAGING = process.env.NEXT_PUBLIC_ORICO_STAGING ?? 36;
export const DESCRIPTION_ID =
  process.env.NEXT_PUBLIC_ORICO_DESCRIPTION_ID ?? 'S000';
export const KAMEI_NO = process.env.NEXT_PUBLIC_ORICO_KAMEI_NO ?? '17290271';
export const KYAKU_SYU = process.env.NEXT_PUBLIC_ORICO_KYAKU_SYU ?? '050';
export const ORICO_SIMULATION_URL =
  process.env.NEXT_PUBLIC_ORICO_SIMULATION_URL ??
  'https://order.orico.co.jp/weborder/start.do';
export const ORICO_PAYMENT_URL =
  process.env.NEXT_PUBLIC_ORICO_PAYMENT_URL ??
  'https://opustest.orico.co.jp/opusd/entry';

export function isOricoFinancingAvailable(
  country: CountryCode,
  variantCTA?: OrderAppCtaType,
) {
  return supportedCountry?.includes(country) && variantCTA === 'ORDER';
}

export const safeConvertToNumber = (
  value: string | number,
  defaultValue = 0,
) => {
  const number = toNumber(value);
  return isNaN(number) ? defaultValue : number;
};

export const fetchAndSetCookies = async () => {
  const response = await fetch('/api/orico/payment');
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const cookies = await response.json();

  // Set each cookie in the browser
  for (const [name, value] of Object.entries(cookies)) {
    setCookie(name, value, 1); // Set cookies with 1 day expiration
  }
};

export const setCookie = (name: string, value: unknown, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
};
